import { render, staticRenderFns } from "./RegisterOwner.vue?vue&type=template&id=a52fd1e2"
import script from "./RegisterOwner.vue?vue&type=script&lang=js"
export * from "./RegisterOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports